import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-6 py-16 lg:py-24">
      <div className="rounded-2xl border p-8 text-center" style={{ background: "var(--bg-cream-card)", borderColor: "var(--border-cream)" }} data-testid="payment-cancel-view">
        <XCircle className="w-10 h-10 mx-auto mb-4" style={{ color: "var(--rose-dark)" }} />
        <div className="eyebrow mb-2">No harm done</div>
        <h2 className="font-serif text-2xl mb-3" style={{ color: "var(--burgundy)" }}>Your checkout was cancelled.</h2>
        <p className="text-sm mb-6" style={{ color: "var(--text-muted)" }}>
          You were not charged. The Temple is here whenever you're ready.
        </p>
        <div className="flex items-center justify-center gap-3">
          <Link to="/store" className="rounded-full px-5 py-2.5 text-sm font-medium" style={{ background: "var(--burgundy)", color: "var(--bg-cream)" }} data-testid="payment-cancel-back-store-link">
            Return to the Store
          </Link>
          <Link to="/" className="rounded-full px-5 py-2.5 text-sm font-medium border" style={{ borderColor: "var(--burgundy)", color: "var(--burgundy)" }} data-testid="payment-cancel-home-link">
            Home
          </Link>
        </div>
      </div>
    </div>
  );
}
